import { useDispatch, useSelector } from "react-redux";
import {
  cartDecrement,
  cartIncrement,
} from "../../redux/productsNCart/actions";

export function CartButton({ d, id, hasIncrease }) {
  const dispatch = useDispatch();
  const { products, cartList } = useSelector((state) => state?.productsNCart);

  const cartIncrementHandler = (id) => {
    dispatch(cartIncrement(id));
  };

  const decrementCartHandler = (id) => {
    dispatch(cartDecrement(id));
  };

  let productItem = [...products].find((item) => item.id === id);
  let cartItem = [...cartList].find((item) => item.id === id);

  return (
    <>
      <button
        disabled={
          hasIncrease
            ? hasIncrease && productItem?.stockQuantity < 1
            : cartItem?.quantity < 1
        }
        onClick={(e) => {
          e.stopPropagation();
          if (hasIncrease) {
            cartIncrementHandler(id);
          } else {
            decrementCartHandler(id);
          }
        }}
        className="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center"
        style={{ cursor: "pointer" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d={d}
          />
        </svg>
      </button>
    </>
  );
}
